export default __webpack_public_path__ + "static/media/WelcomeTern.1d6a0a07.jpg";